import Ripple from 'vue-ripple-directive'
import {
  required, size, passportValidate, numeric,
} from '@validations'
import { mapActions, mapGetters } from 'vuex'
import vSelect from 'vue-select'
import DatePicker from 'vue-persian-datetime-picker'
import jalaali from 'moment-jalaali'
import moment from '@/libs/moment'
import { alphanumeric } from '@/mixins/alphanumeric'
import showErrorMessages from '@/mixins/showErrorMessages'
import checkFileSize from '@/mixins/checkFileSize'
import GeneralApis from '@/services/apis/documents/general'
import ProfileApis from '@/services/apis/profile'
import { toEnglishDigits, resizeImage } from '@/utils'

const profile = new ProfileApis()
const general = new GeneralApis()
export default {
  components: {
    vSelect,
    DatePicker,
  },
  directives: {
    Ripple,
  },
  mixins: [alphanumeric, showErrorMessages, checkFileSize],
  data() {
    return {
      NationalId: '',
      identityCertificate: '',
      company_name: '',
      id_type: '',
      idTypes: [],
      company_national_id: '',
      registration_city: '',
      registration_date: '',
      company_type_id: '',
      required,
      passportValidate,
      size,
      numeric,
      pending: false,
      expiration_date: '',
      file_front: null,
      file_proof: null,
      file_back: null,
      generals: '',
      show: false,
      isHidden: true,
      lable: 'national-id',
      placeholder: 'national-id',
      commitmentTextModal: false,
      currentUpload: 0,
      uploadSize: 0,
      isPreparingFiles: false,
    }
  },
  computed: {
    ...mapGetters(['allGeneralDocuments', 'getCitizenship', 'getMaxUploadSize']),

    maxUploadSize() {
      return this.getMaxUploadSize
    },
    timestamp() {
      return this.generals && this.generals.document ? moment((this.generals.document.tickets.lengths > 0 ? this.generals.document.tickets[0].updated_at : this.generals.document.updated_at)).format('YYYY-MM-DD') : ''
    },
    isRTL() {
      return this.$store.state.appConfig.layout.isRTL
    },
    convertedExpiration() {
      return jalaali(this.expiration_date, 'jYYYY/jMM/jDD').format('YYYY-MM-DD')
    },
    MAX_IMAGE_UPLOAD_SIZE() {
      return process.env.VUE_APP_MAX_IMAGE_UPLOAD_SIZE
    },
    isCryptoMode() {
      return process.env.VUE_APP_ACTIVE_MODULES.includes('CRYPTO')
    },
  },

  watch: {
    '$store.state.Messaging.event': {
      async handler(newVal) {
        if (newVal === 'document_general') {
          await this.getData()
          this.$store.dispatch('Messaging/setEvent', '')
        }
      },
      immediate: true,
    },
  },

  async created() {
    await this.getData()
    await this.getList()
    this.show = false
  },
  methods: {
    ...mapActions(['saveDocumentGeneral']),
    async getData() {
      this.show = true
      await general.getDataInfo().then(res => {
        // eslint-disable-next-line prefer-destructuring
        this.generals = res.data.results[0]
      }).finally(() => {
        this.show = false
      })
    },
    async getList() {
      await general.getIdTypeList().then(res => {
        this.idTypes = res.data.results
      })
    },
    async submit() {
      if (await this.$refs.generalTab.validate()) {
        const imageSize = (process.env.VUE_APP_RESIZE_IMAGE_SIZE ? process.env.VUE_APP_RESIZE_IMAGE_SIZE : 3072) * 1024
        this.isPreparingFiles = true
        this.pending = true

        const fileFront = document.getElementById('file_front')?.files[0]
          ? await resizeImage(document.getElementById('file_front')?.files[0], imageSize)
          : null

        const fileProof = document.getElementById('file_proof')?.files[0]
          ? await resizeImage(document.getElementById('file_proof')?.files[0], imageSize)
          : null

        const fileBack = document.getElementById('file_back')?.files[0]
          ? await resizeImage(document.getElementById('file_back')?.files[0], imageSize)
          : null

        const data = {
          id_number: toEnglishDigits(this.NationalId),
          identity_type_id: this.id_type.id,
          file_front: fileFront,
          file_proof: fileProof,
          file_back: fileBack,
          id_expiration_date: this.id_type && this.id_type.identity !== 'identity_certificate' ? this.convertedExpiration : undefined,
          id_number2: this.id_type && this.id_type.identity === 'identity_certificate' ? this.identityCertificate : undefined,
        }
        this.isPreparingFiles = false
        await general.SaveGeneralInfo(data, e => {
          this.uploadSize = e.total
          this.currentUpload = e.loaded
        }).then(res => {
          this.$swal({
            title: res.data.message,
            icon: 'success',
            timer: 2500,
            showConfirmButton: false,
          })
          if (!this.generals) {
            this.generals = { status: '' }
            this.generals.status = 'pending'
          } else {
            this.generals.status = 'pending'
          }
          this.getData()
          profile.get()
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
          })
        }).finally(() => {
          this.pending = false
          this.uploadSize = 0
          this.currentUpload = 0
          this.isPreparingFiles = false
        })
      }
    },
    changeLable() {
      if (this.id_type) {
        if (this.id_type.identity === 'nationality_identification_card') {
          this.lable = 'national-id'
          this.placeholder = 'national-id'
        } else if (this.id_type.identity === 'passport') {
          this.lable = 'passport'
          this.placeholder = 'passport'
        } else if (this.id_type.identity === 'identity_certificate') {
          this.lable = 'national-id'
          this.placeholder = 'national-id'
        }
      }
    },
  },

  baseUrl() {
    return process.env.VUE_APP_BASE_IMAGE_URL
  },
}
